var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg79383313812201(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M369.944,121.432c-1.437-0.385-2.88-0.75-4.323-1.084c-19.3-4.517-39.199-5.11-58.932-4.741 c-18.058,0.33-37.232,4.306-55.005-0.147c-12.194-3.052-22.992-10.202-32.535-18.391c-11.185-9.612-21.159-20.933-34.05-28.101 c-32.17-17.896-64.409-6.778-88.404,15.471c-0.041,0.03-0.075,0.072-0.107,0.104c-1.53,1.408-3.015,2.873-4.467,4.369 c-0.041,0.03-0.075,0.072-0.107,0.104c-13.941,14.4-24.616,32.489-30.177,50.245c-2.741,8.753-4.946,17.62-6.616,26.537 c-0.022,0.036-0.024,0.077-0.026,0.119c-0.345,1.82-0.672,3.646-0.966,5.472c-0.002,0.042-0.014,0.08-0.017,0.122 c-13.229,81.591,18.094,165.937,94.915,205.897c36.81,19.153,80.285,35.681,122.731,32.557c27.122-1.983,52.063-14.7,73.468-30.85 c46.229-34.878,82.384-87.071,92.971-144.54C448.032,181.713,422.754,135.682,369.944,121.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M369.944,121.432c-1.437-0.385-2.88-0.75-4.323-1.084 c-19.3-4.517-39.199-5.11-58.932-4.741c-18.058,0.33-37.232,4.306-55.005-0.147c-12.194-3.052-22.992-10.202-32.535-18.391 c-11.185-9.612-21.159-20.933-34.05-28.101c-32.17-17.896-64.409-6.778-88.404,15.471c-0.041,0.03-0.075,0.072-0.107,0.104 c-1.53,1.408-3.015,2.873-4.467,4.369c-0.041,0.03-0.075,0.072-0.107,0.104c-13.941,14.4-24.616,32.489-30.177,50.245 c-2.741,8.753-4.946,17.62-6.616,26.537c-0.022,0.036-0.024,0.077-0.026,0.119c-0.345,1.82-0.672,3.646-0.966,5.472 c-0.002,0.042-0.014,0.08-0.017,0.122c-13.229,81.591,18.094,165.937,94.915,205.897c36.81,19.153,80.285,35.681,122.731,32.557 c27.122-1.983,52.063-14.7,73.468-30.85c46.229-34.878,82.384-87.071,92.971-144.54 C448.032,181.713,422.754,135.682,369.944,121.432z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table_line"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 447.267,
    y1: 409.781,
    x2: 467.497,
    y2: 409.781
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 287.707,
    y1: 409.781,
    x2: 310.164,
    y2: 409.781
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 111.377,
    y1: 409.781,
    x2: 186.751,
    y2: 409.781
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 82.123,
    y1: 409.781,
    x2: 99.184,
    y2: 409.781
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Stars_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stars"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M159.365,179.258c0,0,1.249,8.139-5.651,11.589c0,0,8.328,1.785,9.093,9.832 c0,0,0.163-10.992,4.945-12.331C167.752,188.349,161.277,188.248,159.365,179.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M258.473,180.278c0,0-0.397,4.991-4.962,6.069c0,0,4.679,2.219,4.008,7.088 c0,0,1.631-6.482,4.648-6.606C262.167,186.829,258.35,185.865,258.473,180.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M263.967,163.278c0,0-0.397,4.991-4.962,6.069c0,0,4.679,2.219,4.008,7.088 c0,0,1.631-6.482,4.647-6.606C267.661,169.829,263.844,168.865,263.967,163.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M147.18,163.644c0,0-0.349,7.434-4.928,9.724c0,0,6.32,1.478,7.46,8.945 c0,0-0.948-8.329,4.156-10.089C153.867,172.224,148.449,169.61,147.18,163.644z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Dish_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dish"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 376.879,
    cy: 417.453,
    rx: 65.77,
    ry: 14.728
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 377.248,
    cy: 414.731,
    rx: 57.641,
    ry: 11.824
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M338.125,399.009c-2.6-1.172-5.612-1.609-8.333-0.756c-2.721,0.853-5.062,3.131-5.563,5.938 c-0.474,2.656,0.72,5.408,2.584,7.359c1.864,1.951,4.327,3.216,6.814,4.261c6.871,2.887,14.328,4.371,21.78,4.333 c6.27-0.032,12.546-1.125,18.785-0.509c5.968,0.59,11.677,2.723,17.596,3.687c6.029,0.982,12.255,0.732,18.185-0.731 c6.139-1.515,12.678-5.23,13.744-11.463c0.729-4.263-1.545-8.748-5.164-11.116c-3.618-2.368-8.344-2.73-12.474-1.447 c1.086-0.337-0.506-9.995-0.794-11.296c-1.988-8.961-12.627-15.365-21.47-14.891c-5.937,0.318-11.867,4.35-13.119,10.162 c-2.026-1.128-4.867-0.704-6.894,0.423c-2.027,1.126-3.404,3.342-3.516,5.658c-3.907-3.562-9.949-4.388-14.982-2.771 c-2.095,0.673-4.103,1.872-5.288,3.726c-0.843,1.319-1.218,2.875-1.579,4.398C338.051,395.604,338.512,397.379,338.125,399.009 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M337.718,399.184c-2.6-1.172-5.612-1.609-8.333-0.756c-2.721,0.853-5.062,3.131-5.563,5.938 c-0.474,2.656,0.72,5.408,2.584,7.359c1.864,1.951,4.327,3.216,6.814,4.261c6.871,2.887,14.328,4.371,21.78,4.333 c6.27-0.032,12.545-1.125,18.785-0.509c5.968,0.59,11.677,2.722,17.596,3.687c6.029,0.982,12.255,0.732,18.186-0.731 c6.138-1.515,12.678-5.23,13.744-11.463c0.729-4.263-1.545-8.748-5.164-11.116c-3.619-2.368-8.344-2.73-12.474-1.447 c1.086-0.337-0.506-9.995-0.794-11.296c-1.988-8.961-12.627-15.365-21.47-14.891c-5.937,0.318-11.867,4.35-13.119,10.162 c-2.026-1.128-4.867-0.704-6.894,0.423c-2.027,1.126-3.404,3.342-3.516,5.658c-3.907-3.562-9.949-4.388-14.981-2.771 c-2.095,0.673-4.103,1.872-5.288,3.726c-0.843,1.319-1.218,2.875-1.579,4.398C337.644,395.779,338.104,397.554,337.718,399.184 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.19,
      fill: "#FFFFFF"
    },
    d: "M338.154,399.242c-2.6-1.172-5.612-1.609-8.333-0.756 c-2.721,0.853-5.062,3.131-5.563,5.938c-0.474,2.656,0.72,5.408,2.584,7.359c1.864,1.951,4.327,3.216,6.814,4.261 c6.871,2.887,14.328,4.371,21.78,4.333c6.27-0.032,12.546-1.125,18.785-0.509c5.968,0.59,11.677,2.722,17.596,3.687 c6.029,0.982,12.255,0.732,18.185-0.731c6.139-1.515,12.678-5.23,13.744-11.463c0.729-4.263-1.545-8.748-5.164-11.116 s-8.344-2.73-12.474-1.447c1.086-0.337-0.506-9.995-0.795-11.296c-1.988-8.96-12.627-15.365-21.47-14.891 c-5.937,0.318-11.867,4.35-13.119,10.162c-2.026-1.128-4.868-0.704-6.894,0.423c-2.027,1.126-3.404,3.342-3.516,5.658 c-3.907-3.562-9.949-4.388-14.982-2.771c-2.095,0.673-4.103,1.872-5.288,3.726c-0.843,1.319-1.218,2.875-1.579,4.398 C338.08,395.837,338.541,397.612,338.154,399.242z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M401.874,381.162c-4.672-4.228-12.401-3.606-17.457,0.155c-5.056,3.761-7.787,9.956-8.952,16.148 c-1.969-1.416-4.778-1.266-6.886-0.067c-2.108,1.2-3.587,3.283-4.579,5.496c-3.516-2.638-8.762-2.675-12.314-0.086 c-1.297,0.945-2.354,2.175-3.556,3.238c-3.325,2.939-7.808,4.532-12.242,4.349c-4.434-0.183-8.771-2.139-11.843-5.342 c0,0-3.57,5.066,10.149,10.813c13.719,5.747,22.617,5.005,30.032,4.078c7.415-0.927,16.685,0.742,23.173,2.966 c6.488,2.225,25.398,2.41,32.072-4.82c6.674-7.23,5.932-21.319-13.348-20.021C406.123,398.07,406.339,385.202,401.874,381.162z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M363.44,369.272c-2.712-1.24-3.956-4.59-3.581-7.549c0.375-2.958,2.033-5.587,3.806-7.984c1.773-2.398,3.728-4.72,4.861-7.478 c4.437-10.801-5.109-23.57-0.859-34.445"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M402.235,368.441c-2.545-0.779-4.027-3.486-4.507-6.103c-1.508-8.217,4.155-15.96,5.377-24.225 c1.014-6.857-1.075-13.752-3.139-20.37"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M383.409,366.031c-2.707-2.549-2.405-7.002-0.944-10.422c1.461-3.419,3.848-6.441,4.844-10.024 c1.173-4.218,0.186-8.978-2.567-12.381"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M359.48,319.838c-0.235,3.762,0.002,7.552,0.704,11.255"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M359.684,342.832c0.341,3.733-2.121,7.052-4.091,10.241c-2.24,3.626-3.992,7.611-4.635,11.824 c-0.643,4.213-0.12,8.675,1.937,12.408"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M225.342,192.143l0.96,12.23l0.022,0.287c-0.762-0.099-1.612-0.144-2.539-0.155 c-6.634-0.033-16.966,2.186-24.35,4.007c-5.155,1.281-8.875,2.373-8.875,2.373l-1.115-4.404l-4.184-16.524 c-3.411-2.925-8.61-14.438-8.61-14.438c-4.228-0.651-9.493-4.493-10.63-9.857c-1.137-5.365,5.464-4.846,5.464-4.846l4.283-2.627 l5.365-14.626c0,0-4.714-10.895,4.559-15.277c9.261-4.393,40.787,10.884,40.787,10.884l3.411,14.306 c4.382,1.788-0.254,12.507-0.254,12.507s0.419,0.165,0.905,6.501C231.027,178.82,225.342,192.143,225.342,192.143z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M214.812,158.145c1.396,5.325,6.332,9.11,6.15,10.486c-0.232,1.755-2.407,4.141-4.369,4.166"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.907,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M224.517,149.589c0,0-4.323-3.525-7.68,1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M199.685,176.465c0,0,2.21,5.749,10.981,5.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.907,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M205.319,154.096c-3.161-1.95-7.543-1.778-9.858,2.537"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M204.848,162.483c0.297,1.556-0.142,2.946-0.98,3.106c-0.838,0.16-1.757-0.972-2.054-2.528 c-0.297-1.556,0.142-2.946,0.98-3.106C203.632,159.795,204.551,160.927,204.848,162.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M222.878,158.98c0.297,1.556-0.142,2.946-0.98,3.106c-0.838,0.16-1.757-0.972-2.054-2.527 c-0.297-1.556,0.142-2.946,0.98-3.106C221.662,156.293,222.582,157.424,222.878,158.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M176.242,164.699c0,0-7.326-6.359-9.644-1.964c-2.318,4.395,5.213,14.471,12.282,11.383"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M225.471,140.899c0,0,0.56,18.332,2.585,22.415c2.024,4.083,3.77,6.102,1.634,16.745 c-2.136,10.643-10.305,23.068-19.044,23.896c-8.739,0.828-28.616-12.423-34.302-28.958"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M176.438,165.453c0,0,5.316-2.753,4.35-7.516c-0.966-4.763-0.293-5.345,3.518-7.793 c3.811-2.448,1.454-7.514-2.195-12.497c-3.65-4.983,3.292-10.937,8.938-8.433c5.646,2.504,37.853,15.163,46.502,11.402 c8.649-3.762,6.167-15.775-5.48-22.499c0,0-6.287-7.504-4.599-14.42c1.688-6.916-38.656-27.778-57.563,14.723 c0,0-8.972,3.509-10.846,15.591c-1.843,11.886,11.163,27.271,11.163,27.271S174.828,163.646,176.438,165.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M181.883,127.045c2.96-3.983,8.455-5.424,13.367-4.722c4.912,0.702,9.368,3.202,13.559,5.858 c4.191,2.656,8.312,5.546,12.995,7.186c2.66,0.931,5.582,1.437,8.294,0.672c2.147-0.606,4.095-2.059,5.06-4.07"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M173.49,123.822c-3.597,0.24-6.741,2.943-8.14,6.266c-1.398,3.323-1.245,7.14-0.253,10.606 c0.697,2.436,1.781,4.733,2.994,6.964"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M226.046,190.503c-0.606,2.024-0.608,4.178-0.492,6.288c0.144,2.618,0.343,4.812,0.83,7.389"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M185.224,189.278c1.727,6.124,3.647,13.495,5.413,21.689"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M226.592,156.755c0,0,1.633-4.454,4.735-2.48c3.102,1.974-1.833,11.984-1.833,11.984"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M231.12,137.819c0,0,1.549,12.61-2.212,16.592l-2.876,0.885l-1.518-16.742L231.12,137.819z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M157.176,122.028c0,0-10.135-0.71-19.937-12.366s-1.88-19.853,3.029-24.228 c4.908-4.375,16.923-16.393,21.956-21.956c5.033-5.563,15.107-12.707,26.499-10.852c11.391,1.854,22.451,8.682,33.313,11.861 c10.862,3.179,21.629,15.031,23.218,22.713c1.589,7.683-1.831,19.799-5.805,22.714l-6.831-0.213l3.021,10.353 c0,0-40.609-16.055-76.887,14.075l3.065-10.78L157.176,122.028z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M175.835,108.233c-0.048,4.605,0.07,9.212,0.354,13.809l-16.844,12.516l4.12-20.299 L175.835,108.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M175.835,108.233c-0.048,4.605,0.203,9.726,0.487,14.322l-16.977,12.002 l4.12-20.299L175.835,108.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M177.834,52.875c1.588-0.602,3.471,0.1,4.571,1.394c1.1,1.294,1.51,3.059,1.494,4.757 c-0.051,5.555-4.179,10.253-8.706,13.472c-4.527,3.219-9.715,5.566-13.696,9.44c-4.527,4.404-7.18,10.677-7.186,16.993 c-0.006,6.316,2.633,12.594,7.152,17.008c0.445,0.435,0.912,0.847,1.352,1.287l-1.398,5.688c0,0-18.049-2.357-24.177-13.252 c-6.128-10.895-4.225-15.965,1.16-22.406c5.385-6.441,12.388-9.875,19.252-19.644 C164.515,57.844,177.834,52.875,177.834,52.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M177.834,52.875c1.588-0.602,3.471,0.1,4.571,1.394 c1.1,1.294,1.51,3.059,1.494,4.757c-0.051,5.555-4.179,10.253-8.706,13.472c-4.527,3.219-9.715,5.566-13.696,9.44 c-4.527,4.404-7.18,10.677-7.186,16.993c-0.006,6.316,2.633,12.594,7.152,17.008c0.445,0.435,0.912,0.847,1.352,1.287 l-1.398,5.688c0,0-18.049-2.357-24.177-13.252c-6.128-10.895-4.225-15.965,1.16-22.406c5.385-6.441,12.388-9.875,19.252-19.644 C164.515,57.844,177.834,52.875,177.834,52.875z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M159.344,134.557c0,0,27.898-28.915,76.193-13.954l-5.94-16.395c0,0-33.554-9.219-66.133,10.05L159.344,134.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M232.806,112.995c3.437-0.553,10.121-4.365,11.641-7.497c1.52-3.132,1.875-6.706,1.812-10.187 c-0.088-4.96-1.007-9.986-3.367-14.349c-5.177-9.569-16.082-14.262-26.195-18.275c-6.306-2.502-12.612-5.005-18.919-7.507 c-3.829-1.519-7.735-3.056-11.845-3.327c-8.157-0.537-15.853,4.007-21.81,9.604c-5.957,5.598-10.75,12.351-16.801,17.848 c-2.95,2.68-6.189,5.051-8.924,7.95c-2.735,2.899-4.99,6.466-5.39,10.431c-0.575,5.713,2.784,11.141,6.907,15.137 c4.075,3.95,8.168,8.595,21.423,10.166"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M212.903,102.003c2.738-1.628,5.157-3.79,7.082-6.328"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M172.738,109.304c-4.789-1.629-8.782-5.454-10.613-10.17"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M176.249,60.733c-4.483-0.324-8.395,2.962-11.265,6.421c-2.871,3.459-5.433,7.441-9.444,9.468"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M337.845,257.6l-41.283,32.221c0,0-15.852-51.637-16.781-58.075 c-2.535-6.19-11.752-14.834-11.752-14.834s-33.844-1.677-36.284-3.068c-2.439-1.391-2.715-9.493-2.715-9.493 c-0.883-0.011-1.799,0-2.726,0.022c-0.828,0.033-1.667,0.077-2.517,0.132c-8.069,0.596-17.131,2.594-23.997,4.393 c-6.424,1.678-10.928,3.179-10.928,3.179l2.495,10.862l-1.81,2.715c-5.928,4.437-38.413,15.2-46.824,18.997 c-4.576,3.437-10.576,9.28-10.576,9.28s-29.14,57.17-33.665,64.146c-4.526,6.965-4.305,14.593-4.305,14.593 c3.345,7.153,8.268,7.616,13.334,9.372c0.828,0.287,1.667,0.607,2.506,1.004c5.928,2.782,58.216-1.358,58.216-1.358 s-3.764,18.622,13.378,11.535c27.43-11.336,93.009-3.488,93.009-3.488l-1.567-41.968l14.857,16.999c0,0,6.954,4.095,15.31-1.126 c12.716-8.212,49.562-53.558,49.562-53.558C349.214,261.629,337.845,257.6,337.845,257.6z M172.237,323.079l-2.991-2.991 c-5.177-3.135-24.499-6.781-24.499-6.781l13.604-19.65c0,0,14.35,22.204,14.979,24.08 C173.959,319.625,172.237,323.079,172.237,323.079z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M200.848,367.892l3.08,66.364c0,0-10.081-2.52-12.881-6.72c-2.8-4.2-9.044-67.106-9.044-67.106 S187.968,365.932,200.848,367.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "#FFFFFF"
    },
    d: "M200.848,367.892l3.08,66.364c0,0-10.081-2.52-12.881-6.72 c-2.8-4.2-9.044-67.106-9.044-67.106S187.968,365.932,200.848,367.892z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M173.762,318.826l-15.735-24.539l13.196-17.451c0,0,0.972,9.872,6.847,14.454 c9.366,7.306,7.306,29.784,7.306,29.784L173.762,318.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M173.762,318.826l-15.735-24.539l13.196-17.451c0,0,0.972,9.872,6.847,14.454 c9.366,7.306,7.306,29.784,7.306,29.784L173.762,318.826z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M269.599,254.898c0,0,11.444,50.896,18.069,59.027c6.625,8.131,6.774-23.514,9.109-23.954 c2.335-0.44,6.25,18.533,4.744,24.255c0,0,0.904,3.012,4.216,0c3.313-3.012,44.571-41.259,44.571-41.259 s-42.39,53.632-54.509,53.305c-10.251,1.414-21.316-16.899-21.316-16.899L269.599,254.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M269.599,254.898c0,0,11.444,50.896,18.069,59.027 c6.625,8.131,6.774-23.514,9.109-23.954c2.335-0.44,6.25,18.533,4.744,24.255c0,0,0.904,3.012,4.216,0 c3.313-3.012,44.571-41.259,44.571-41.259s-42.39,53.632-54.509,53.305c-10.251,1.414-21.316-16.899-21.316-16.899 L269.599,254.898z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M146.794,310.154l-2.539,3.4c0,0-20.333-2.55-36.746,28.49c-5.067-1.755-9.99-2.219-13.334-9.372 c0,0-0.221-7.628,4.305-14.593c4.526-6.976,34.003-64.807,34.003-64.807s4.448-5.063,10.239-8.62 c21.022-11.099,40.897-14.56,46.824-18.997l1.81-2.715l-2.495-10.862c0,0,4.503-1.501,10.928-3.179l3.324,14.174 c1.132,4.828-1.469,9.751-6.095,11.536l-47.949,18.506c-3.095,1.195-5.63,3.507-7.102,6.481l-26.278,53.085 C116.151,312.207,126.605,301.577,146.794,310.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M146.794,310.154l-2.539,3.4c0,0-20.333-2.55-36.746,28.49 c-5.067-1.755-9.99-2.219-13.334-9.372c0,0-0.221-7.628,4.305-14.593c4.526-6.976,34.003-64.807,34.003-64.807 s6.299-5.708,10.239-8.62c19.91-10.265,40.897-14.56,46.824-18.997l1.81-2.715l-2.495-10.862c0,0,4.503-1.501,10.928-3.179 l3.324,14.174c1.132,4.828-1.469,9.751-6.095,11.536l-47.949,18.506c-3.095,1.195-5.63,3.507-7.102,6.481l-26.278,53.085 C116.151,312.207,126.605,301.577,146.794,310.154z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342.044,255.055l12.651-17.897c0,0,8.948-6.017,12.188-7.56s3.703-4.628,5.245-3.548 c1.543,1.08,0.154,7.406-3.086,9.411c-3.24,2.006-6.943,4.011-6.48,5.4c0.463,1.389,19.285-0.309,19.285-0.309 s24.012-0.325,24.348,1.534c0.337,1.86-14.937,4.637-14.937,4.637s16.43-0.187,16.469,0.755c0.039,0.942-9.372,4.182-9.372,4.182 s6.654,0.346,6.336,1.793c-0.319,1.447-7.107,3.298-7.107,3.298s-13.885,8.485-16.971,9.874 c-3.086,1.388-24.222-1.234-24.222-1.234l-3.613,4.667c0,0-6.106-8.678-12.586-12.381L342.044,255.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M295.395,310.078c0.961-6.651,1.234-13.228,1.289-19.949"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M226.36,204.453c1.031-0.038,2.075-0.064,3.131-0.075l1.016,6.453c0.336,2.136,2.171,3.715,4.333,3.728l32.546,2.214 c2.392,0.015,11.465,12.406,12.986,17.083l16.404,56.115l41.068-32.606c0,0,8.045,1.089,14.934,12.694 c0,0-26.441,35.196-50.442,53.976c-3.505,2.743-11.366,3.357-14.5,0.196c-5.275-5.318-10.053-10.081-13.742-14.963"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M164.845,292.938c2.743-1.77,5.486-3.539,8.229-5.309"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M167.885,294.728c2.174-0.701,4.475-1.007,6.757-0.898"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M158.359,294.14c5.002,6.968,9.636,14.2,13.877,21.655c0.948,1.666,1.223,3.633,0.8,5.502l-19.977,88.38"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M267.387,241.087l6.897,66.566c0.456,14.942,1.568,24.397,2.223,43.119"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M190.525,225.133l9.268,59.341l12.399-4.143c8.534-2.852,17.517-4.122,26.508-3.749l12.659,0.526 l-15.259-63.141h5.788l32.596,95.407l2.015,42.308c0,0-60.653-13.307-94.631,4.643l2.666,26.019c0,0,1.613,7.12,3.323,27.849 l-27.001-0.487l-7.798-0.027l19.698-86.47c0,0,17.04,1.256,16.514-12.424c-0.526-13.681-5.191-82.427-5.191-82.427 L190.525,225.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M215.211,224.57c0,1.558-1.263,2.82-2.82,2.82c-1.558,0-2.821-1.263-2.821-2.82 c0-1.558,1.263-2.821,2.821-2.821C213.948,221.749,215.211,223.012,215.211,224.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M218.434,238.27c0,1.558-1.263,2.821-2.821,2.821c-1.558,0-2.821-1.263-2.821-2.821 c0-1.558,1.263-2.82,2.821-2.82C217.171,235.449,218.434,236.712,218.434,238.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M233.237,313.607c10.195-1.717,20.451-3.069,30.742-4.054"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M215.622,316.949c4.189-0.885,8.392-1.707,12.605-2.468"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M264.003,313.207c-8.289,3.344-16.65,6.51-25.074,9.496"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M262.056,242.414c0.864,5.414,2.112,10.767,3.731,16.006"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M382.026,248.2c0,0,24.046-3.962,24.171-6.113c0.125-2.151-17.279-1.04-21.392-1.355c-4.113-0.314-21.321,1.847-21.891,0.772 c-0.57-1.075,0.822-1.329,4.616-4.495c3.794-3.166,6.575-8.735,5.562-10.506c-1.013-1.771-4.401,2.158-6.972,3.598 c-2.095,1.173-9.979,5.649-11.433,7.611c-1.454,1.962-10.938,15.08-14.542,20.081"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M382.552,247.963c0,0,25.274-2.326,25.177-0.484c-0.161,3.066-17.107,5.487-24.047,5.971"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M383.52,253.612c0,0,21.487-3.005,21.172-0.158c-0.315,2.847-24.748,7.465-24.748,7.465"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M351.886,271.201c2.415-3.462,4.019-5.84,4.019-5.84s20.694,2.266,23.667,1.695c2.973-0.571,16.935-9.521,16.935-9.521"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M361.026,248.08c4.561,0.503,8.738,3.639,10.492,7.879"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M299.963,292.153c2.33,3.57,2.587,8.06,2.773,12.318"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M181.982,357.526l7.408,63.252c0,0-0.347,6.66,5.24,10.026c5.587,3.366,30.09,8.779,43.766,7.924 c13.676-0.855,31.056-1.71,37.324-6.553c6.268-4.844,4.844-17.95,4.844-17.95l4.559-39.604c0,0,4.15-15.124-0.855-19.659 C275.15,346.699,198.121,340.436,181.982,357.526z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M182.003,360.43c0,0,4.202,3.901,10.204,5.702c6.002,1.801,79.84-0.321,88.989-2.111 c9.149-1.79,5.847-9.293,0.746-11.394c-5.102-2.101-52.473-8.996-73.393-4.241C189.948,352.613,178.402,352.927,182.003,360.43z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M182.003,360.43c0,0,4.202,3.901,10.204,5.702c6.002,1.801,79.84-0.321,88.989-2.111 c9.149-1.79,5.847-9.293,0.746-11.394c-5.102-2.101-46.886-8.164-72.085-4.717C191.249,352.112,178.402,352.927,182.003,360.43z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M287.102,358.612c0,1.954-2.13,3.797-5.905,5.409c-8.809,3.797-26.558,6.38-47.012,6.38c-19.527,0-36.581-2.351-45.743-5.861 c-4.548-1.744-7.164-3.764-7.164-5.928c0-6.524,23.688-11.8,52.907-11.8S287.102,352.088,287.102,358.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M281.196,364.021c-8.809,3.797-26.558,6.38-47.012,6.38c-19.527,0-36.581-2.351-45.743-5.861 c6.844-4.283,25.223-7.363,46.814-7.363C255.985,357.177,273.745,360.014,281.196,364.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M181.277,358.612l8.268,65.27c0.386,3.036,2.307,5.663,5.089,6.921c10.409,4.702,38.369,14.129,78.262,3.08 c3.433-0.949,5.928-3.93,6.336-7.473l2.528-21.745l0.254-2.219l2.042-17.562l0.453-3.885l2.594-22.386"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M225.073,438.867c0,0-4.585-5.365-2.435-12.353c0,0-6.092,3.046-6.271,8.421 c0,0-8.959-2.509-7.884-15.589c0,0-5.017,8.063-0.538,16.843C212.425,444.969,225.073,438.867,225.073,438.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M248.396,438.905c0,0,6.537-5.905,8.224-16.449c0,0,2.109,6.116-0.211,13.496 c0,0,6.115-2.32,7.592-9.49c0,0,1.265,8.014-2.531,12.442C257.675,443.334,248.396,438.905,248.396,438.905z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M302.368,387.024c-2.373,8.312-10.895,17.374-20.608,17.639l0.254-2.219 c8.323-0.43,16.094-8.533,18.224-16.028c0.519-1.821,1.391-6.281-1.744-8.301c-1.755-1.115-3.488-1.446-5.32-1.004 c-4.747,1.159-8.268,7.164-8.301,7.23c-0.177,0.309-0.486,0.497-0.817,0.541l0.453-3.885c1.645-2.141,4.526-5.144,8.135-6.027 c2.417-0.585,4.78-0.154,7.043,1.292C302.776,378.238,303.747,382.168,302.368,387.024z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M226.221,362.167c5.418,3.07,12.096,3.24,18.159,1.814c2.105-0.495,4.201-1.186,5.975-2.422"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M258.291,362.574c-1.68,1.692-3.761,2.983-6.022,3.738"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.907,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M188.492,406.542c-19.817,2.344-21.782-20.525-16.455-24.148c5.327-3.622,15.813,8.762,15.813,8.762"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M240.831,361.549l-39.329-71.481c0,0-4.306-2.584-4.019,2.584c0.287,5.167,36.508,69.35,36.508,69.35L240.831,361.549z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M225.895,377.026c11.895,0.729,26.952,0.446,39.91-3.541"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M204.944,374.491c0,0,3.999,0.811,10.304,1.568"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M167.579,282.769c-8.062,9.091-15.391,18.832-21.892,29.097"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M141.149,311.479c-4.845-1.129-10.001-0.888-14.719,0.686"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M139.552,251.684c0,0,18.043,10.31,24.67,26.143"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M154.453,316.092c0.339,12.916,8.39,26.127,8.39,26.127l29.59-4.518l-1.964-5.734 c1.012,0.498,3.059,0.328,4.448,0.652c8.713,2.031,23.031,1.63,23.031,1.63c3.262-2.947,4.313-4.715,5.256-6.386 c2.406-4.262,0.136-5.424,0.136-5.424c3.491-4.888,0.811-8.42,0.811-8.42c5.161-2.944,2.961-4.559,2.961-4.559 c-3.323-5.185-22.91-2.947-22.91-2.947l-17.195,14.488l-11.651-2.036L154.453,316.092z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M185.414,321.187l2.582-0.844l16.206-13.83c0,0,21.157-1.121,22.673,2.678c1.516,3.799-2.895,5.559-6.694,7.074"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M223.463,314.917c0,0,5.228,2.288-1.949,8.655"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M222.772,322.6c2.301-1.298,3.812,4.563-4.257,7.376"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M223.36,328.244l-5.914,6.352c0,0-13.313,1.16-25.282-2.698l-1.312,0.382"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M122.342,323.153c5.593-6.014,13.737-9.575,21.95-9.596c1.71-0.004,3.398,0.329,5.031,0.837 c5.786,1.801,29.579,4.508,36.842,7.056l6.303,15.906c-24.91,6.303-58.119,6.814-78.08,5.887 c-4.402-0.204-9.665-1.754-14.321-4.126c-5.45-2.776-7.535-9.509-4.698-14.927l35.829-68.97c0.98-1.872,7.966-8.473,9.93-9.253 l18.259-8.812c1.372-0.679,4.534-2.021,5.989-2.495l20.192-6.775c1.536-0.61,5.958-4.155,5.564-5.76l-2.493-10.163 c0,0,15.841-6.693,37.721-7.508"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Kitchen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wall"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 67.671,
    y: 197.869,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 21.614,
    height: 13.037
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.278,
    y: 214.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 21.614,
    height: 13.037
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 420.46,
    y: 193.636,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 21.614,
    height: 13.037
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.988,
    y: 210.447,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 21.614,
    height: 13.037
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.208,
    y: 375.623,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.057,
    height: 4.863
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.259,
    y: 359.892,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 20.253,
    height: 13.037
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Graphics_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 293.25,115.874 293.25,61.084 430.692,61.084 430.692,157.99 410.213,157.99  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 293.25,
    y1: 135.873,
    x2: 293.25,
    y2: 127.64
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 311.679,157.99 293.25,157.99 293.25,141.274  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 328.477,
    cy: 70.877,
    r: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M363.919,71.025c0,1.06-0.86,1.92-1.92,1.92c-1.06,0-1.92-0.86-1.92-1.92c0-1.06,0.86-1.92,1.92-1.92 C363.06,69.105,363.919,69.965,363.919,71.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M397.783,70.877c0,1.06-0.86,1.92-1.92,1.92c-1.06,0-1.92-0.86-1.92-1.92s0.86-1.92,1.92-1.92 C396.924,68.957,397.783,69.817,397.783,70.877z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M334.057,144.438c-1.645,0.023-2.984-1.319-2.958-2.964l0.925-57.333c0.094-2.077-0.611-3.897-2.69-3.897h-1.424 c-2.046,0-3.708,0.938-3.662,2.984l1.319,58.28c0.037,1.637-1.28,2.983-2.917,2.983h-0.2c-1.595,0-2.895,1.281-2.917,2.876 l-0.371,26.553c-0.04,2.872,2.295,5.211,5.167,5.176l9.445-0.115c2.854-0.035,5.125-2.403,5.041-5.256l-0.784-26.472 c-0.047-1.593-1.364-2.853-2.957-2.831L334.057,144.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M326.635,84.419c0-0.937,0.76-1.697,1.697-1.697c0.937,0,1.697,0.76,1.697,1.697c0,0.937-0.76,1.697-1.697,1.697 C327.395,86.116,326.635,85.356,326.635,84.419z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 322.241,
    y1: 171.645,
    x2: 322.241,
    y2: 156.857
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 325.065,
    y1: 171.645,
    x2: 325.065,
    y2: 156.857
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 328.305,
    y1: 171.406,
    x2: 328.267,
    y2: 156.87
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 331.76,
    y1: 171.597,
    x2: 331.76,
    y2: 156.808
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 335.41,
    y1: 171.562,
    x2: 335.41,
    y2: 156.773
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M394.247,85.325c0-0.937,0.76-1.697,1.697-1.697c0.937,0,1.697,0.76,1.697,1.697s-0.76,1.697-1.697,1.697 C395.007,87.022,394.247,86.263,394.247,85.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M396.282,148.114l3.567-63.534c0.117-2.091-1.547-3.851-3.641-3.851h-0.661c-2.044,0-3.689,1.68-3.646,3.724l0.798,37.78 c0.184,8.688,0.356,17.377,0.559,26.065c0.018,0.77-0.38,1.478-1.026,1.898c-2.427,1.575-4.12,4.198-5.002,6.98 c-1.164,3.674-1.365,8-0.711,11.796c0.727,4.22,3.66,8.83,8.242,9.454c4.502,0.613,7.735-3.357,8.908-7.271 c1.19-3.97,1.676-8.75,0.673-12.798c-0.481-1.942-1.432-3.721-2.662-5.318c-0.824-1.07-2.607-2.187-4.059-2.786 C396.765,149.899,396.23,149.04,396.282,148.114z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 389.155,
    y1: 168.009,
    x2: 389.155,
    y2: 159.523
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 401.278,
    y1: 168.009,
    x2: 401.278,
    y2: 159.523
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 392.765,
    y1: 169.972,
    x2: 392.765,
    y2: 157.365
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 398.507,
    y1: 169.972,
    x2: 398.507,
    y2: 157.365
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 395.573,
    y1: 174.085,
    x2: 395.573,
    y2: 155.417
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M360.237,85.068c0-0.937,0.76-1.697,1.697-1.697s1.697,0.76,1.697,1.697c0,0.937-0.76,1.697-1.697,1.697 S360.237,86.005,360.237,85.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M364.254,141.039l2.661-57.221c0.097-2.078-1.562-3.816-3.643-3.816h-2.513c-2.091,0-3.754,1.755-3.641,3.843l3.114,57.616 c0.043,0.792-0.342,1.545-1.014,1.966c-3.023,1.894-11.322,8.06-11.521,18.763c-0.242,13.092,14.547,18.911,23.032,14.062 c8.3-4.743,14.281-24.334-5.205-33.128C364.714,142.758,364.213,141.927,364.254,141.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M362.563,171.635c0-0.51,0.414-0.924,0.924-0.924c0.51,0,0.924,0.414,0.924,0.924c0,0.51-0.414,0.924-0.924,0.924 C362.977,172.559,362.563,172.145,362.563,171.635z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 357.598,
    cy: 169.325,
    r: 0.924
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 369.492,
    cy: 169.325,
    r: 0.924
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M362.563,165.63c0-0.51,0.414-0.924,0.924-0.924c0.51,0,0.924,0.414,0.924,0.924c0,0.51-0.414,0.924-0.924,0.924 C362.977,166.554,362.563,166.14,362.563,165.63z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 357.598,
    cy: 163.32,
    r: 0.924
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 369.492,
    cy: 163.32,
    r: 0.924
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M362.563,159.625c0-0.51,0.414-0.924,0.924-0.924c0.51,0,0.924,0.414,0.924,0.924s-0.414,0.924-0.924,0.924 C362.977,160.549,362.563,160.135,362.563,159.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M356.674,157.316c0-0.51,0.414-0.924,0.924-0.924c0.51,0,0.924,0.414,0.924,0.924c0,0.51-0.414,0.924-0.924,0.924 C357.087,158.239,356.674,157.826,356.674,157.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M368.568,157.316c0-0.51,0.414-0.924,0.924-0.924s0.924,0.414,0.924,0.924c0,0.51-0.414,0.924-0.924,0.924 S368.568,157.826,368.568,157.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M362.563,149.463c0,0.51,0.414,0.924,0.924,0.924c0.51,0,0.924-0.414,0.924-0.924c0-0.51-0.414-0.924-0.924-0.924 C362.977,148.539,362.563,148.953,362.563,149.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M356.674,151.772c0,0.51,0.414,0.924,0.924,0.924c0.51,0,0.924-0.414,0.924-0.924c0-0.51-0.414-0.924-0.924-0.924 C357.087,150.848,356.674,151.262,356.674,151.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.9535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M368.568,151.772c0,0.51,0.414,0.924,0.924,0.924s0.924-0.414,0.924-0.924c0-0.51-0.414-0.924-0.924-0.924 S368.568,151.262,368.568,151.772z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg79383313812201);
export default __webpack_public_path__ + "static/media/7938331_3812201.b1fdf475020e966c7309cbd86c142256.svg";
export { ForwardRef as ReactComponent };